import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import {
  breakpointSizes,
  fluidFontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import SalesforceExplainerList from './SalesforceExplainerList';
import Pagination from './Pagination';
import SearchFilters from './SearchFilters';

const StyledSalesforceExplainerListing = styled.section`
  ${sectionPaddings('30px', '60px')};
`;

const StyledInner = styled.div`
  display: grid;

  ${minBreakpointQuery.medium`
    grid-template-columns: .45fr .55fr;
    column-gap: 30px;
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: .4fr .6fr;
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: .35fr .65fr;
    column-gap: 45px;
  `}
`;

const StyledHeader = styled.header``;

const StyledHeading = styled(Heading)`
  ${fluidFontSize(
    '20px',
    '32px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};
  margin-bottom: 15px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 45px;
  `}
`;

const StyledSearchFilters = styled(SearchFilters)`
  ${maxBreakpointQuery.mlarge`
    margin-top: 50px;
  `}

  ${maxBreakpointQuery.medium`
    margin-top: 40px;
  `}

  ${maxBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.medium`
    grid-area: 1/1/4/1
  `}
`;

const StyledContent = styled.div`
  margin-top: 30px;
  scroll-margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 40px;
    scroll-margin-top: 40px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 50px;
    scroll-margin-top: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 60px;
    scroll-margin-top: 60px;
  `}
`;

const StyledList = styled(SalesforceExplainerList)`
  ${minBreakpointQuery.small`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.medium`
    grid-template-columns: 1fr;
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

const SalesforceExplainerListing = ({
  heading,
  text,
  items,
  searchItems,
  searchResults,
  setSearchResults,
  location,
  totalPageCount,
  listingPage,
  currentPageCount,
  businessFunctions,
  products,
  popularFeatures,
}) => {
  const [filteredResults, setFilteredResults] = useState();
  const resultsRef = useRef(null);
  return (
    <StyledSalesforceExplainerListing>
      <Container>
        <StyledInner>
          <StyledHeader>
            <StyledHeading>{heading}</StyledHeading>
            <HtmlContent content={text} />
          </StyledHeader>
          <StyledSearchFilters
            searchItems={searchItems}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            location={location}
            businessFunctions={businessFunctions}
            products={products}
            popularFeatures={popularFeatures}
            filteredResults={filteredResults}
            setFilteredResults={setFilteredResults}
            resultsRef={resultsRef}
          />
          <StyledContent ref={resultsRef}>
            {filteredResults !== null && searchResults !== null ? (
              <StyledList items={filteredResults || searchResults || items} />
            ) : (
              <p>No Salesforce explainer posts match that search criteria</p>
            )}
            {filteredResults === undefined && searchResults === undefined && (
              <Pagination
                totalPageCount={totalPageCount}
                listingPage={listingPage}
                currentPageCount={currentPageCount}
              />
            )}
          </StyledContent>
        </StyledInner>
      </Container>
    </StyledSalesforceExplainerListing>
  );
};

export default SalesforceExplainerListing;
